import { fromLonLat, toLonLat } from 'ol/proj';
import { type Coords } from '#shared/lib/coords';
import type { Coordinate } from 'ol/coordinate';

export function fromCoords(coords: Coords) {
  return fromLonLat([coords[1], coords[0]]);
}

export function toCoords(coordinate: Coordinate): Coords {
  const [lon, lat] = toLonLat(coordinate);
  return [lat, lon];
}

export function areCoordsEqual(coords1: Coords, coords2: Coords) {
  return coords1[0] === coords2[0] && coords1[1] === coords2[1];
}
